import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DOCUMENT_FILE_TYPE } from '../../../model/enums/document-file-type.enum';
import { DOCUMENT_STATUS } from 'src/app/product-capture/model/enums/document-status.enum';
import { DOCUMENT_TYPE } from '../../../model/consts/document-type.const';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { DocService } from 'src/app/product-capture/services/doc.service';
import { DocumentFile } from 'src/app/product-capture/model/interfaces/document-file.interface';
import { getDocErrorMessage } from '../documents-tab/getDocErrorMessage';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  @Input() productId: number = null;
  @Output() goToDocuments: EventEmitter<void> = new EventEmitter();
  loading = true;
  documents = [];
  lastVersions: DocumentFile[] = [];
  documentType: DOCUMENT_FILE_TYPE | string = null;
  documentTypeItems = DOCUMENT_TYPE;
  types = DOCUMENT_FILE_TYPE;

  constructor(
    private docService: DocService,
    private dcAlertService: DcAlertService
  ) {}

  ngOnInit(): void {
    this.fetchDocuments();
  }

  downloadFile(docId: number): void {
    this.docService.download(docId);
  }

  getFileType(fileName: string): string {
    if (
      fileName === DOCUMENT_FILE_TYPE.SPREAD_SHEET ||
      fileName === DOCUMENT_FILE_TYPE.FINAL_TERMS
    ) {
      return 'document-spreadsheet';
    }

    return 'document-text';
  }

  getTypeName(type: string): string {
    return this.types[type];
  }

  getFileName(fileName: string): string {
    const paths = fileName?.split('/') || [fileName];
    return paths[paths.length - 1];
  }

  openDocuments(): void {
    this.goToDocuments.emit();
  }

  private fetchDocuments(): void {
    this.loading = true;

    this.docService.fetchAllDocs(this.productId).subscribe(
      (docs) => {
        this.lastVersions = [];

        docs.sort((a, b) => Number(new Date(b.createdAt).getTime()) - Number(new Date(a.createdAt).getTime()));

        this.documents = docs.filter(doc => {
          const isApproved = doc.status !== DOCUMENT_STATUS.IN_REVIEW
            && doc.status !== DOCUMENT_STATUS.NOT_AVAILABLE;
          return isApproved;
        });

        this.documents.forEach(doc => {
          const hasDoc = this.lastVersions.some(version => version.type === doc.type && version.language === doc.language);

          if (!hasDoc) {
            this.lastVersions.push(doc);
          }
        });
      },
      error => {
        this.dcAlertService.showAlert({
          type: 'danger',
          message: getDocErrorMessage(error),
        });
      },
      () => {
        this.loading = false;
    });
  }
}
